module.exports = __webpack_public_path__ + "media/customizations/regencyatesperanza/back-c70d7baceea4c477d796de77eca884c3.jpg";